export default "__VITE_ASSET__D8XX_WaB__"